module.exports = __webpack_public_path__ + "assets/img/a63048645de221894b82a1f8f235ef8f.svg";